module.exports = "<div id=\"circle-container\" class=\"example\">\n    <app-label [id]=\"labelId\" [message]=\"labelMessage\"></app-label>\n    <div id=\"{{circlesId}}\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/src/app/circles/circles.component.html
// module id = ../../../../../src/app/circles/circles.component.html
// module chunks = 1